import { namespace } from 'vuex-class';
import { IVideoRecorderState } from '@/video/recorder/store/video-recorder.types';

export const VideoRecorder = namespace('video/videoRecorder');

export enum EVideoRecorderAction {
  StartRecord = 'startRecord',
  StopRecord = 'stopRecord',
  SetStream = 'setStream',
  CloseStream = 'closeStream',
  SetError = 'setError',
  Save = 'save',
  SaveSuccess = 'saveSuccess',
  SaveFailed = 'saveFailed',
  ClearData = 'clearData',
  AddRecordedBlob = 'addRecordedBlob',
  ToggleTimer = 'toggleTimer',
  IncreaseDuration = 'increaseDuration',
  SetSuperBufferUrl = 'setSuperBufferURL',
}

export enum EVideoRecorderMutation {
  SetRecordStatus = 'setRecordStatus',
  SetStream = 'setStream',
  CloseStream = 'closeStream',
  SetError = 'setError',
  SetLoading = 'setLoading',
  SetCreatedVideoId = 'setCreatedVideoId',
  ResetState = 'resetState',
  SetRecordedBlobs = 'setRecordedBlobs',
  SetSuperBuffer = 'setSuperBuffer',
  SetElapsedSeconds = 'setElapsedSeconds',
  SetSuperBufferURL = 'setSuperBufferURL',
}

export enum EVideoRecorderGetter {
  FormattedTime = 'formattedTime',
}

export const state: IVideoRecorderState = {
  loading: false,
  recorder: {
    stream: null,
    recordedVideo: null,
    isRecording: false,
    recordedBlobs: [],
    superBuffer: null,
    superBufferURL: null,
  },
  elapsedSeconds: 0,
  error: null,
  createdVideoId: null,
};
